export const isValidPassword = (password) => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/;
  return passwordRegex.test(password);
};

// Password rules matching User.validatePassword (packages/api/models/user.js).
// specialChars is the server's list, sent with the invite/reset link data, so it is never copied here.
export const getPasswordRules = (password, specialChars) => {
  const chars = specialChars.split('');
  const isOther = c => !/[A-Za-z\d\s]/.test(c);
  const hasAllowedSpecial = [...password].some(c => chars.includes(c));
  const hasDisallowedSpecial = [...password].some(c => isOther(c) && !chars.includes(c));

  return [
    { label: 'At least 8 characters', met: password.length >= 8 },
    { label: 'At least 1 letter', met: /[A-Za-z]/.test(password) },
    { label: 'At least 1 uppercase letter', met: /[A-Z]/.test(password) },
    { label: 'At least 1 number', met: /\d/.test(password) },
    {
      label: `At least 1 special character, using only: ${chars.join(' ')}`,
      met: hasAllowedSpecial && !hasDisallowedSpecial,
    },
    { label: 'No spaces', met: !/\s/.test(password) },
  ];
};

// The first unmet rule as a sentence for the on-click check, or '' if every rule is met.
export const getPasswordError = (password, specialChars) => {
  const unmet = getPasswordRules(password, specialChars).find(rule => !rule.met);
  return unmet ? `Password requirement not met: ${unmet.label}` : '';
};
